<template>
  <div>
    <!-- CHECKBOX -->
    <v-checkbox
      v-model="model"
      class="ml-4"
      :label="$t('replaceCertChainsForAllMatchingSigners')"
      @change="handleDialog"
    ></v-checkbox>

    <!-- DIALOG -->
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="600">
        <v-card>
          <v-card-title class="headline green">
            <v-icon left large>mdi-file-replace-outline</v-icon>
            {{ $t('replace') }}
          </v-card-title>
          <v-form ref="form" v-model="formValid">
            <v-card-text>
              <p class="subtitle-2">{{ $t('dialog.confirm.typeToConfirm', { event: validReplaceConfirmText }) }}</p>
              <v-text-field v-model="confirmText" :label="validReplaceConfirmText + ` *`" :rules="[rules.required, rules.match]" required></v-text-field>
              <small>*{{ $t('indicatesRequiredField') }}</small>
            </v-card-text>
          </v-form>
          <v-card-actions>
            <v-spacer />
            <v-btn color="blue darken-3" text @click="cancel">{{ $t('close') }}</v-btn>
            <v-btn class="primary" :disabled="!formValid" @click="confirm">
              {{ $t('replace') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'ReplaceCertChainsForAllMatchingSigners',

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      dialog: false,
      formValid: false,
      confirmText: '',
      validReplaceConfirmText: 'REPLACE',
      rules: {
        required: v => !!v || this.$t('validation.requiredField'),
        match: v => (v === this.validReplaceConfirmText) || this.$t('validation.keywordMustBeIdentical')
      }
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },

      set(val) {
        this.$emit('input', val)
      }
    }
  },

  methods: {
    handleDialog(val) {
      if (val) {
        this.openDialog()
        return
      }

      this.$emit('input', false)
    },

    openDialog() {
      this.dialog = true

      this.$nextTick(() => {
        this.confirmText = ''
        this.formValid = false

        if (this.$refs.form) {
          this.$refs.form.reset()
        }
      })
    },

    confirm() {
      if (!this.$refs.form.validate()) {
        return
      }

      this.dialog = false
      this.$emit('input', true)
    },

    cancel() {
      this.dialog = false
      this.$emit('input', false)
    }
  }
}
</script>

<style>
</style>
